import React from 'react';
import * as styledComponents from './styles'
import { Container, Row, Col } from 'react-bootstrap';
import TC from 'media/tc.png';
import VisibilitySensor from 'react-visibility-sensor';
import { useHistory } from "react-router";

const TeamCreation = React.forwardRef((props, ref) => {
  const history = useHistory();
  const changeVisibility = (isVisible)=>{
    if(isVisible){
      history.push('landing?section=teamassembly&type=scrolled')
    }
  }
  return (
    <VisibilitySensor partialVisibility onChange={changeVisibility}>
    <styledComponents.TeamCreationContainer ref={ref}>
      <Container>
        <Row>
          <Col md>
            <styledComponents.HeadTitle>SERVICES</styledComponents.HeadTitle>
            <styledComponents.Title>
              WE ASSEMBLE YOUR TECH TEAM
            </styledComponents.Title>
            <styledComponents.ContainerListPhone>
              <styledComponents.TCImage src={TC}/>
            </styledComponents.ContainerListPhone>
            <styledComponents.Description>
              We assemble an optimal team for your startup and establish a development plan based on Scrum in which you can have a daily track. In this way, you can adjust your product faster and more efficiently when your client needs it.             <br /> <br />
            <b>Investment: Monthly budget allocation</b>
            </styledComponents.Description>
            <styledComponents.CallToAction onClick={()=>{window.open("https://calendly.com/luisenriquecgongora")}}>LEARN MORE</styledComponents.CallToAction>
          </Col>
          <Col md>
            <styledComponents.ContainerListDesktop>
              <styledComponents.TCImage src={TC}/>
            </styledComponents.ContainerListDesktop>
          </Col>
        </Row>
      </Container>
    </styledComponents.TeamCreationContainer>
    </VisibilitySensor>
  );
});

export default TeamCreation;
